import { render } from "./LotteryImage.vue?vue&type=template&id=5480d549&ts=true"
import script from "./LotteryImage.vue?vue&type=script&lang=ts"
export * from "./LotteryImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__